var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-relative"},[_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.previewBusy,"can-cancel":false}}),_vm._v(" "),_c('iframe',{ref:"iframe",staticStyle:{"height":"75vh","width":"100%"},attrs:{"src":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97520708","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Template/TemplatePreview.vue
// module id = null
// module chunks = 